import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var hintColor = '#6D6D71';
var placeholderColor = '#6D6D71';
var statusColor = function statusColor(_ref) {
  var theme = _ref.theme,
    status = _ref.status;
  switch (status) {
    case 'success':
      return theme.colors.positiveD;
    case 'error':
      return theme.colors.negativeD;
    case 'warn':
      return theme.colors.warnD;
    default:
      return '';
  }
};
export var TrailingIcon = styled.span.withConfig({
  displayName: "Field__TrailingIcon",
  componentId: "sc-vhpkyl-0"
})(["display:flex;align-items:center;padding-right:9px;color:", ";"], function (_ref2) {
  var theme = _ref2.theme,
    _ref2$trailingIconCol = _ref2.trailingIconColor,
    trailingIconColor = _ref2$trailingIconCol === void 0 ? 'ui' : _ref2$trailingIconCol;
  return theme.colors[trailingIconColor];
});
export var TrailingText = styled.span.withConfig({
  displayName: "Field__TrailingText",
  componentId: "sc-vhpkyl-1"
})(["display:inline-flex;align-items:center;font-weight:500;"]);
var borderStyles = css(["border:1px solid ", ";border-radius:", ";box-shadow:inset 0 0 2px ", ";transition:all 0.3s ease-in-out;"], function (_ref3) {
  var theme = _ref3.theme,
    isFocused = _ref3.isFocused;
  return isFocused ? theme.colors.primaryM : theme.colors.terciaryM;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme,
    isFocused = _ref5.isFocused;
  return isFocused ? theme.colors.primaryM : theme.colors.terciaryM;
});
export var StyledField = styled.div.withConfig({
  displayName: "Field__StyledField",
  componentId: "sc-vhpkyl-2"
})(["display:flex;", ";background-color:", ";", ";", " ", "{padding-right:16px;", " ", "}textarea,input{width:100%;margin:0;font-family:", ";font-size:15px;line-height:1.5;text-align:", ";", " &::placeholder{color:", ";}", " ", " &:disabled{cursor:not-allowed;background-color:", ";}}"], function (_ref6) {
  var inline = _ref6.inline;
  return !inline ? 'margin-bottom: 8px;' : '';
}, function (_ref7) {
  var readOnly = _ref7.readOnly,
    theme = _ref7.theme;
  return readOnly ? theme.colors.terciaryM : ' #fff';
}, function (_ref8) {
  var bordered = _ref8.bordered;
  return bordered && borderStyles;
}, function (_ref9) {
  var bordered = _ref9.bordered,
    status = _ref9.status,
    theme = _ref9.theme;
  return bordered && status && css(["border:1px solid ", ";border-radius:", ";box-shadow:inset 0 0 2px ", ";"], statusColor({
    theme: theme,
    status: status
  }), theme.borderRadius, theme.colors.terciaryM);
}, TrailingText, function (_ref10) {
  var size = _ref10.size;
  return size === 'small' ? 'padding-right: 6px;' : '';
}, function (_ref11) {
  var size = _ref11.size;
  return size === 'medium' ? 'padding-right: 9px;' : '';
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.bodyFontFamily;
}, function (_ref13) {
  var textAlign = _ref13.textAlign;
  return textAlign;
}, function (_ref14) {
  var bordered = _ref14.bordered;
  return bordered && css(["padding:16px;color:", ";"], function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.terciaryDD;
  });
}, placeholderColor, function (_ref16) {
  var size = _ref16.size;
  return size === 'small' && css(["", ";padding:6px;"], getFont(-1, 'default'));
}, function (_ref17) {
  var size = _ref17.size;
  return size === 'medium' && css(["", ";padding:9px;"], getFont(0, 'default'));
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.terciaryL;
});
var labelSmallStyles = css(["height:auto;margin-bottom:3px;", ";"], getFont(-1, 'compact'));
var labelMediumStyles = css(["height:auto;", ";margin-bottom:3px;"], getFont(0, 'compact'));
export var Label = styled.div.withConfig({
  displayName: "Field__Label",
  componentId: "sc-vhpkyl-3"
})(["display:block;height:40px;margin-bottom:8px;font-weight:500;", ";", ";", " ", ""], getFont(1, 'compact'), maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), getFont(0, 'compact')), function (_ref19) {
  var size = _ref19.size;
  return size === 'small' && labelSmallStyles;
}, function (_ref20) {
  var size = _ref20.size;
  return size === 'medium' && labelMediumStyles;
});
export var Hint = styled.div.withConfig({
  displayName: "Field__Hint",
  componentId: "sc-vhpkyl-4"
})(["color:", ";", ";", " ", " ", ""], hintColor, getFont(0, 'default'), function (_ref21) {
  var theme = _ref21.theme,
    status = _ref21.status;
  return status && "color: ".concat(statusColor({
    theme: theme,
    status: status
  }), ";");
}, function (_ref22) {
  var size = _ref22.size;
  return size === 'small' ? getFont(-1, 'default') : '';
}, function (_ref23) {
  var size = _ref23.size;
  return size === 'medium' ? getFont(-1, 'default') : '';
});
var readOnlyStyles = css(["input{cursor:not-allowed;background-color:", ";}"], function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.terciaryM;
});
export var FormControl = styled.div.withConfig({
  displayName: "Field__FormControl",
  componentId: "sc-vhpkyl-5"
})(["", " ", ""], function (_ref25) {
  var theme = _ref25.theme,
    status = _ref25.status;
  return status && "color: ".concat(statusColor({
    theme: theme,
    status: status
  }), ";");
}, function (_ref26) {
  var readOnly = _ref26.readOnly;
  return readOnly && readOnlyStyles;
});